import { useImperativeHandle } from 'react'

import { useSetState } from 'ahooks'
import { $getNodeByKey } from 'lexical'

import { useEditor } from '../../hooks/useEditor'
import { $isEmojiNode } from '../../nodes/EmojiNode'
import { EmojiPanel } from '../EmojiPanel'
import { EmojiObject } from '../EmojiPanel/interface'
import { FloatPopover } from '../FloatPopover'

import { EmojiPickerProps } from './interface'

export const EmojiPicker = ({ ref }: EmojiPickerProps) => {
  const [state, setState] = useSetState({
    nodeKey: '',
    open: false
  })

  const editor = useEditor()

  useImperativeHandle(ref, () => ({
    open(nodeKey) {
      setState({
        nodeKey,
        open: true
      })
    },
    close(nodeKey) {
      if (state.nodeKey === nodeKey) {
        setState({
          open: false
        })
      }
    }
  }))

  const handleEmojiSelect = (value: EmojiObject) => {
    if (!state.nodeKey) {
      return
    }

    setState({
      open: false
    })

    editor.update(() => {
      const node = $getNodeByKey(state.nodeKey)
      if ($isEmojiNode(node)) {
        node.setTextContent(value.emoji)
        // 光标移动文本后面
        node.selectNext()
      }
    })
  }

  return (
    <FloatPopover
      {...state}
      trigger='click'
      onOpenChange={open => setState({ open })}
    >
      <EmojiPanel onSelect={handleEmojiSelect} />
    </FloatPopover>
  )
}
